import React, { InputHTMLAttributes } from 'react';
import styled from 'styled-components';

interface InputComponentProps extends InputHTMLAttributes<HTMLInputElement> {
  value: string;
  placeholder: string;
  required?: boolean;
}

const Container = styled.div`
  position: relative;
  font-family: 'Cormorant', serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 28.8px;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 10px 0;
  background: transparent;
  border: none;
  outline: none;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: #000;
`;

interface PlaceholderLabelProps {
  isHidden: boolean;
  required?: boolean;
}

const PlaceholderLabel = styled.label<PlaceholderLabelProps>`
  position: absolute;
  top: 10px;
  left: 0;
  color: #aaa;
  pointer-events: none;
  transition: opacity 0.3s ease;
  opacity: ${({ isHidden }) => (isHidden ? 0 : 1)};
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;

  &:after {
    content: ${({ required }) => (required ? "' *'" : "''")};
    color: red;
  }
`;

const TitleInput: React.FC<InputComponentProps> = ({ value, onChange, placeholder, required, ...inputProps }) => {
  return (
    <Container>
      <StyledInput
        value={value}
        onChange={onChange}
        placeholder=" "
        required={required}
        {...inputProps}
      />
      <PlaceholderLabel isHidden={value.length > 0} required={required}>
        {placeholder}
      </PlaceholderLabel>
    </Container>
  );
};

export default TitleInput;
